import { useState } from 'react'
import { useLoaderData, useNavigate, redirect } from 'react-router'
import { BranchPageHeading } from '@/components/subscription/branch-page-heading'
import { TextLink } from '@/components/subscription/text-link'
import { formatTime } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'

export const loader = async () => {
  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0]

  if (!subscription) {
    return redirect('/subscription/branch/mypage')
  } else {
    return subscriptions
  }
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'green' })
}

export const SubscriptionBranchMypageCancel: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData<typeof loader>()
  const [errorMessage, setErrorMessage] = useState('')

  const navigate = useNavigate()
  const subscription = subscriptions[0]
  const [checked, setChecked] = useState(false)

  const handleClickCancel: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      await createClient(Subscriptions).postSubscriptionsIdCancel(subscription.id)
      navigate('/subscription/branch/mypage', { state: { message: '定期便を解約しました。' } })
    } catch (error) {
      setErrorMessage(error.response.data.error.message_displayable)
    }
  }

  return (
    <div className="w-full space-y-8 pt-4 pb-18">
      <BranchPageHeading
        main="定期便解約のお手続き"
        sub={subscription && `${formatTime(1000 * subscription.attributes.skip_deadline)}までのお手続きで、次回発送分から定期便を停止できます`}
      />
      <div className="flex flex-col items-center gap-4">
        <h3 className="text-[15px] font-bold text-black leading-relaxed">必ずお読みください</h3>
        <ul className="list-disc pl-4 text-[15px] text-black leading-relaxed">
          <li>上記の期限を過ぎてしまった場合は、次回のお届けをキャンセルできません。</li>
          <li>
            次回分のみお休み（スキップ）することも可能です。その場合は
            <TextLink to="/subscription/branch/mypage/skip">こちら</TextLink>からお手続きいただけます。
          </li>
        </ul>
      </div>
      <div className="w-full flex flex-col items-center gap-8">
        <label className="flex items-center gap-2 cursor-pointer">
          <div className="flex flex-row items-center gap-2">
            <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
            <span>上記を確認しました</span>
          </div>
        </label>
        <div className="flex flex-col items-center gap-2 w-full">
          {!!errorMessage && <p>{errorMessage}</p>}
          <button
            type="button"
            disabled={!checked}
            className="w-full py-5 bg-black text-white text-[15px] font-medium rounded-full cursor-pointer hover:bg-main disabled:bg-main transition-colors"
            onClick={handleClickCancel}
          >
            定期便を解約する
          </button>
        </div>
        <TextLink to="/subscription/branch/mypage">マイページに戻る</TextLink>
      </div>
    </div>
  )
}
